import { parseSqliteDatetime } from '~/shared/sql-time.js';

/**
 * Render a libSQL `YYYY-MM-DD HH:MM:SS` UTC timestamp as a short
 * relative-time string ("just now" / "5m ago" / "yesterday" / "3d
 * ago" / etc.). Computed once at render time — does not auto-refresh
 * while the page is open.
 */
export function relativeTime(iso: string): string {
  const diffSec = Math.round((Date.now() - parseSqliteDatetime(iso)) / 1000);
  if (diffSec < 60) return 'just now';
  const min = Math.round(diffSec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day === 1) return 'yesterday';
  if (day < 7) return `${day}d ago`;
  if (day < 30) return `${Math.round(day / 7)}w ago`;
  if (day < 365) return `${Math.round(day / 30)}mo ago`;
  return `${Math.round(day / 365)}y ago`;
}
